import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RiskShieldConfiguration } from './risk-shield-config.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RiskShieldConfigService {

  private apiUrl = `${environment.API_INSPEC}RiskShield`

  constructor(private http: HttpClient) { }

  // Create
  create(riskShieldConfig: RiskShieldConfiguration): Observable<RiskShieldConfiguration> {
    return this.http.post<RiskShieldConfiguration>(this.apiUrl, riskShieldConfig);
  }

  getById(id: number): Observable<RiskShieldConfiguration> {
    return this.http.get<RiskShieldConfiguration>(`${this.apiUrl}/${id}`);
  }

  getByAssetId(assetId: number): Observable<RiskShieldConfiguration> {
    return this.http.get<RiskShieldConfiguration>(`${this.apiUrl}/${assetId}`);
  }

  // Update
  update(riskShieldConfig: RiskShieldConfiguration): Observable<RiskShieldConfiguration> {
    return this.http.put<RiskShieldConfiguration>(this.apiUrl, riskShieldConfig);
  }

  // Delete
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
